import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL;

async function loadConfig() {
  try {
    const response = await fetch("/config.json");
    const config = await response.json();
    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("Failed to load config.json. Using default .env API URL", error);
  }
}

loadConfig().then(() => {});

export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${url}`, { ...options });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    throw new Error(error?.message || "Failed to fetch");
  }
}

export async function deleteImpactedAreasApi(id: string): Promise<void> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/impacted-areas/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete impacted area');
    }
  } catch (error: any) {
    throw new Error(error?.message || 'Failed to delete impacted area');
  }
}

export async function createImpactedAreas(body: Record<string, any>): Promise<any> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/impacted-areas`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) {
      const errorMessage = data?.message || "Failed to create impacted area.";
      if (response.status === 401 || response.status === 403) {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(errorMessage);
    }
    return data;
  } catch (error: any) {
    console.error("API Error:", error?.message);
    throw new Error(error?.message || "An unexpected error occurred.");
  }
}

export async function updateImpactedAreasApi(id: any, body: any): Promise<void> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/impacted-areas/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error("Failed to update");
    }
    return data;
  } catch (error: any) {
    console.error("Error in updateImpactedAreasApi:", error);
    throw new Error(error?.message || "Failed to update risk");
  }
}

interface ImpactAreaResponse {
  name: string;
  description?: string;
}

export async function fetchOneImpactedAreasApi(
  endpoint: string
): Promise<ImpactAreaResponse | null> {
  try {
    const response = await authService.apiCall(`${BASE_URL}/${endpoint}`, { method: 'GET' });
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error: any) {
    console.error("API Fetch Error:", error);
    return null;
  }
}
